/** 环境枚举 预发布环境直接使用release配置，所以没有独立的预发布配置 */
export enum Env {
  develop = 'develop',
  test = 'test',
  release = 'release'
}

export const VERSION = process.env.VERSION

export const IS_TEST = process.env.TEST

export const IS_DEV = process.env.NODE_ENV === 'development'

export const IS_PRODUCTION = process.env.NODE_ENV === 'production' && !IS_TEST

/** 是否私有化版本 */
export const IS_PRIVATE = process.env.PRIVATE

/** 是否 window server 版本 */
export const IS_SERVER = process.env.SERVER

/** 是否 ARM 架构私有化版本 */
export const IS_ARM = process.env.ARM

console.log('IS_DEV', IS_DEV)
console.log('IS_TEST', IS_TEST)
console.log('IS_PRODUCTION', IS_PRODUCTION)
console.log('IS_PRIVATE', IS_PRIVATE)
console.log('IS_SERVER', IS_SERVER)
console.log('IS_ARM', IS_ARM)

/** 当前后端环境 [develop, test, release] */
export const CURRENT_ENV = (() => {
  /** 使用 127.0.0.1访问本地时调用生产环境接口，以便于开发切换接口环境 */
  const LOCAL_RELEASE_MOCK_HOST = '127.0.0.1'

  if (process.env.NODE_ENV === 'development' && !window.location.host.includes(LOCAL_RELEASE_MOCK_HOST)) {
    return Env.develop
  }

  if (process.env.TEST) {
    return Env.test
  }

  return Env.release
})()

/** 助手（云端版 iframe）地址映射 */
const AIDE_ORIGIN: Record<Env, string> = {
  develop: 'http://127.0.0.1:81',
  // develop: 'http://192.168.31.254:81',
  
  test: 'https://test-cloud-pivotclaw-cn.zhhainiao.com', // 需绑host：140.143.221.64
  release: 'https://cloud.pivotclaw.cn',
}

/** 助手云端版地址（团队版 iframe 嵌入） */
export const AIDE_URL = AIDE_ORIGIN[CURRENT_ENV]

console.log('AIDE_URL', AIDE_URL)

